const Raven = require('raven-js')

if (process.env.REACT_APP_DEMO) {
	module.exports =  {
		API_ROOT: 'https://api.demo.pootsy.be',
		BASE_URL: 'https://demo.pootsy.be',
		PRO_BASE_URL: 'https://demo.pro.pootsy.be',
		IS_MOBILE_DEVICE: /Mobi/.test(navigator.userAgent),
		errorReportConfig: Raven.config('https://d656bb31a72b4db780570bbe120e47a6@sentry.io/246900'),
		sentryReport: (err, context) => { Raven.captureException(err, { extra: context }) },
		gtmID: "",
	}
} else if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_STAGING) {
	module.exports =  {
		API_ROOT: 'https://api.pootsy.be',
		BASE_URL: 'https://pootsy.be',
		PRO_BASE_URL: 'https://pro.pootsy.be',
		IS_MOBILE_DEVICE: /Mobi/.test(navigator.userAgent),
		errorReportConfig: Raven.config('https://d656bb31a72b4db780570bbe120e47a6@sentry.io/246900'),
		sentryReport: (err, context) => { Raven.captureException(err, { extra: context }) },
		gtmID: "GTM-P699PZT",
	}
} else if(process.env.REACT_APP_STAGING){
	module.exports =  {
		API_ROOT: 'https://api.staging.pootsy.be',
		BASE_URL: 'https://staging.pootsy.be',
		PRO_BASE_URL: 'https://staging.pro.pootsy.be',
		IS_MOBILE_DEVICE: /Mobi/.test(navigator.userAgent),
		errorReportConfig: Raven.config('https://d656bb31a72b4db780570bbe120e47a6@sentry.io/246900'),
		sentryReport: (err, context) => { Raven.captureException(err, { extra: context }) },
		gtmID: "GTM-58BRHPR",
	}
} else {
	module.exports =  {
		API_ROOT: 'http://localhost:3000',
		BASE_URL: 'http://localhost:8000',
		PRO_BASE_URL: 'https://staging.pro.pootsy.be',
		IS_MOBILE_DEVICE: /Mobi/.test(navigator.userAgent),
		errorReportConfig: { install: () => {} },
		sentryReport: () => {},
		gtmID: "",
	}
}



// WEBPACK FOOTER //
// ./src/config.js